import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Button, PageContainer } from '@core/components/ui';

/**
 * 403 Forbidden Page
 *
 * Displayed when a user tries to access a resource they don't have permission for.
 */
export function ForbiddenPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          {/* Title */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            {t('errors.forbidden.title', 'Acceso Denegado')}
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-8">
            {t(
              'errors.forbidden.message',
              'No tienes permisos para acceder a esta página. Contacta con tu administrador si crees que esto es un error.'
            )}
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate(-1)} variant="secondary">
              <Icon icon="lucide:arrow-left" className="w-4 h-4 mr-2" />
              {t('common.goBack', 'Volver')}
            </Button>

            <Button onClick={() => navigate('/')} variant="primary">
              <Icon icon="lucide:home" className="w-4 h-4 mr-2" />
              {t('common.goHome', 'Ir al inicio')}
            </Button>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
